<ng-container *transloco="let t">
  <raf-text variant="h3" color="primary-color" [gutterBottom]="true">{{
    t("PRODUCT_DETAIL.TECHNICAL_ATTRIBUTES")
  }}</raf-text>

  <mat-list dense class="label-value-list" *ngIf="attributes">
    <ng-container *ngFor="let attr of attributes">
      <mat-list-item *ngIf="attr.code">
        <raf-text variant="body-medium" mat-line>{{ t(attr.name) }}</raf-text>
        <ng-container *ngFor="let value of attr.values; let last = last">
          <raf-text variant="body-medium">{{ value }}</raf-text>
          <ng-container *ngIf="!last">,</ng-container>
        </ng-container>
      </mat-list-item>
    </ng-container>
  </mat-list>
</ng-container>
